export default "__VITE_ASSET__C8sG09FI__"